const formatAmount = ({ amount, currency }) => {
	const amountWithCents = amount / 100;
	const formattedAmount = new Intl.NumberFormat('en', {
		style: 'currency',
		currency: 'USD',
	}).format(amountWithCents);

	if (amount && currency) {
		return `${formattedAmount} ${currency.toUpperCase()}`;
	}
	return formattedAmount;
};

export default formatAmount;
